import cx from "classnames"
import styles from "./StatusBox.module.scss"
import { X } from "react-feather"

const StatusBox = ({ status, onClick, className }) => {
  return (
    <div
      className={cx(
        styles.infoContainer,
        {
          [styles.success]: status === "success",
          [styles.error]: status === "error",
        },
        className
      )}
    >
      {status === "success" && (
        <div>
          Vielen Dank für Ihre Anfrage, wir melden uns sobald wie möglich, spätestens am nächsten Werktag bei Ihnen
        </div>
      )}
      {status === "successss" && (
        <div>
          Vielen Dank für Ihre Anfrage, wir melden uns sobald wie möglich, spätestens am nächsten Werktag bei Ihnen
        </div>
      )}

      {status === "error" && (
        <div>
          Ups, da ist etwas schiefgelaufen.
          <br />
          Bitte versuchen Sie es erneut, oder schreiben Sie eine E-Mail an{" "}
          <a className={styles.link} href="mailto:anfrage@planmaschine.de">
            anfrage@planmaschine.de
          </a>
        </div>
      )}

      <button className="self-start mb-2" onClick={onClick}>
        <X className="w-6 h-6" />
      </button>
    </div>
  )
}

export default StatusBox
